import React, { useEffect, useRef } from 'react'
import SignaturePad from 'react-signature-pad'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './signature.css'

export const Signature = props => {
    const { context, element, modelPath } = props;
    const inputModel = context.readModel(modelPath, element.defaultValue || "");

    let hiddenSignature = useRef(null);
    let signature = useRef(null);
    let container = useRef(null);
    let image = useRef(null);

    const clear = () => {
        signature.current.clear();
        hiddenSignature.current.value = ''
        validator();
    }

    const handleEnd = () => {
        const newValue = signature.current.toDataURL();
        hiddenSignature.current.value = newValue;
        validator();
    }

    const validator = () => {
        const errors = context.validateElement(hiddenSignature.current, element, hiddenSignature.current.value);
        context.updateModel(modelPath, hiddenSignature.current.value, errors);
    }

    useEffect(() => {
        context.validators.subscribe(validator);
        return () => context.validators.unsubscribe(validator);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context]);

    useEffect(() => {
        if (context.isReadOnly)
        {
            container.current.className = "d-none";
            image.current.className = "";
            image.current.src = inputModel.value;
            return;
        }
        
        container.current.className = "";
        image.current.className = "d-none";
        signature.current.fromDataURL(inputModel.value);        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hiddenSignature, signature, container, image]);

    return (
        <div className="input-group">
            <div className={"form-control h-auto" + (inputModel.errors.length !== 0 ? " is-invalid" : "") + (element.className ? " " + element.className : "")}>
                <input 
                    type="text" 
                    ref={hiddenSignature}
                    autoComplete="off"
                    className="d-none" 
                    defaultValue={inputModel.value}
                    required={element.required}                    
                />
                <div ref={container}>
                    <SignaturePad            
                        ref={signature}                                    
                        redrawOnResize={true}                        
                        onEnd={handleEnd} />                         
                </div>
                <img ref={image} alt={element.text}></img>
            </div>
            {!context.isReadOnly && 
                <div className="input-group-append">
                    <button className="btn btn-outline-secondary" type="button" onClick={clear}><FontAwesomeIcon icon="trash-alt"></FontAwesomeIcon></button>
                </div>
            }
        </div>
    )
}

export default Signature;